import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NumexGame from "@/game/NumexGame";
import AdminApp from "@/admin/AdminApp";
import Privacy from "@/game/Privacy";
import Terms from "@/game/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NumexGame />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
